import log from '../logger/log';

export const DEFAULT_KEEP_ALIVE_INTERVAL = 540000; // 9 minutes
export const DEFAULT_KEEP_ALIVE_MESSAGE = '{}';

const instances = {};

export default class DamWebSocketKeepAliveManager {
    constructor({
        client,
        assetId,
        onError,
        logPrefix = 'damWebSocketKeepAliveManager',
        keepAliveInterval = DEFAULT_KEEP_ALIVE_INTERVAL,
        keepAliveMessage = DEFAULT_KEEP_ALIVE_MESSAGE,
    } = {}) {
        if (instances[assetId]) {
            return instances[assetId];
        }

        this.client = client;
        this.assetId = assetId;
        this.keepAliveInterval = keepAliveInterval;
        this.onError = onError;
        this.logPrefix = logPrefix;
        this.keepAliveMessage = keepAliveMessage;
        this.intervalId = null;

        instances[assetId] = this;
    }

    static getInstance(assetId) {
        return instances[assetId];
    }

    start() {
        log.debug(`${this.logPrefix}: start keep alive interval for assetId: ${this.assetId}`);
        this.intervalId = setInterval(() => this.sendKeepAliveMessage(), this.keepAliveInterval);
    }

    stop() {
        log.debug(`${this.logPrefix}: stop keep alive interval for assetId: ${this.assetId}`);
        if (this.intervalId) clearInterval(this.intervalId);
    }

    sendKeepAliveMessage() {
        try {
            if (!this.client) return;
            this.client.send(this.keepAliveMessage);
        } catch (e) {
            this.onError();
        }
    }
}
